// extracted by mini-css-extract-plugin
export default {"fr-view":"ImageContainer_fr-view__yTXnH","container":"ImageContainer_container__-zZhg","image":"ImageContainer_image__-Zp6D"};